import { Ionicons } from '@expo/vector-icons';
import { useEffect, useState } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';

import { useTranslation } from 'react-i18next';
import { useTheme } from '@/contexts/ThemeContext';
import { supabase } from '@/lib/supabase';

type FreezeStatus = {
  frozen: boolean;
  suspended: boolean;
  frozen_until: string | null;
  freeze_reason: string | null;
};

export function FreezeBanner() {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const [status, setStatus] = useState<FreezeStatus | null>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let active = true;
    async function check() {
      const { data } = await supabase.rpc('get_my_freeze_status');
      if (active && data) setStatus(data as FreezeStatus);
    }
    void check();
    // Ανανέωση κάθε 60s ώστε να εξαφανιστεί αυτόματα μετά τη λήξη
    const interval = setInterval(() => void check(), 60_000);
    return () => { active = false; clearInterval(interval); };
  }, []);

  if (!status || dismissed) return null;

  if (status.suspended) {
    return (
      <View style={[styles.banner, { backgroundColor: '#7f1d1d' }]}>
        <Ionicons name="ban-outline" size={16} color="#fca5a5" />
        <Text style={styles.text}>
          {t('freeze.suspended')}
        </Text>
      </View>
    );
  }

  if (status.frozen && status.frozen_until) {
    const until = new Date(status.frozen_until).toLocaleString('el-GR', {
      day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
    });
    return (
      <View style={[styles.banner, { backgroundColor: '#78350f' }]}>
        <Ionicons name="warning-outline" size={16} color="#fcd34d" />
        <Text style={styles.text}>
          {t('freeze.frozen', { until })}
        </Text>
        <Pressable onPress={() => setDismissed(true)} hitSlop={8}>
          <Ionicons name="close" size={16} color="#fcd34d" />
        </Pressable>
      </View>
    );
  }

  return null;
}

const styles = StyleSheet.create({
  banner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingHorizontal: 16,
    paddingVertical: 10,
  },
  text: {
    flex: 1,
    color: '#fff',
    fontSize: 12,
    lineHeight: 16,
  },
});
